import { render, staticRenderFns } from "./SetСarrier.vue?vue&type=template&id=602c90f6&scoped=true&"
import script from "./SetСarrier.vue?vue&type=script&lang=js&"
export * from "./SetСarrier.vue?vue&type=script&lang=js&"
import style0 from "./SetСarrier.vue?vue&type=style&index=0&id=602c90f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602c90f6",
  null
  
)

export default component.exports